import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, withModifiers as _withModifiers, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "home_header_container"
}
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "select_text_wrapper" }
const _hoisted_4 = { class: "select_text" }
const _hoisted_5 = { class: "badge_wrapper" }
const _hoisted_6 = { class: "badge_text" }
const _hoisted_7 = ["onClick"]

import { ref, onMounted, computed, watch } from 'vue'
import { useRouter } from 'vue-router'
import { useThemeColor, useThemeColorWithAlpha } from '@/utils/theme'
import { CollegeDetail } from '@/api/Models/HomeConfig'
import { College } from '@/api/Models/CollegeList'
import { useUsersStore } from '@/stores/users'
import { storeToRefs } from 'pinia'
import { useAuthStore } from '@/stores/login'
import { useCommunityStore } from '@/stores/community'
import { isFeishu } from '@/utils/feishu'
import { getMessageUnreadCount } from '@/api/requests/NewsRequests'


export default /*@__PURE__*/_defineComponent({
  __name: 'HomeHeader',
  props: {
    collegeDetail: {},
    collegeList: {}
  },
  emits: ['setIdHandle'],
  setup(__props: any, { emit: __emit }) {

_useCssVars(_ctx => ({
  "cd27b4a4": (_unref(themeColor)),
  "d8f1cbac": (_unref(themeColorWithAlpha))
}))


const emit = __emit

// 替换原先从 localStorage 读取的 token，改为从 Pinia 派生，保持响应式
const authStore = useAuthStore()
const token = computed(() => authStore.getAccessToken)
const shouldShowHeader = computed(() => !isFeishu || !!token.value)

const count = ref('0')

const getMsgCount = async () => {
  const res = await getMessageUnreadCount()
  if (res.code === 1) {
    count.value = String(res.data)
  }
}

// 延迟创建 SSE：仅在 token 可用或非飞书环境时触发
onMounted(() => {
  if (!isFeishu || !!token.value) {
    getMsgCount()
  }
})

// 监听 token，在飞书环境下 token 到位后再建立 SSE
watch(token, (val) => {
  if (isFeishu && val) {
    getMsgCount()
  }
})

const router = useRouter()
const searchHandle = () => {
  router.push('/courseSearch')
}

const usersStore = useUsersStore()
const { collegeId } = storeToRefs(usersStore)
const selectCollege = (id: string) => {
  emit('setIdHandle', id)
  masterShow.value = false
  const communityStore = useCommunityStore()
  communityStore.setIsRefresh(true)
}

const skipPage = () => {
  router.push('/news')
}

const themeColor = useThemeColor()
const themeColorWithAlpha = useThemeColorWithAlpha(0.08)

const masterShow = ref()
const hideMaster = () => {
  masterShow.value = false
}
const showMaster = () => {
  masterShow.value = true
}

return (_ctx: any,_cache: any) => {
  return (shouldShowHeader.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", {
          class: "college_wrapper",
          onClick: showMaster
        }, [
          _createElementVNode("img", {
            src: __props.collegeDetail.whiteLogoPreviewUrl,
            class: "home_title_img"
          }, null, 8, _hoisted_2),
          _cache[2] || (_cache[2] = _createElementVNode("div", { class: "title_separator" }, null, -1)),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("p", _hoisted_4, _toDisplayString(__props.collegeDetail.collegeName), 1),
            _createElementVNode("i", {
              class: _normalizeClass(["iconfont icon-icon_shouye_xiala select_icon", { roate: masterShow.value }])
            }, null, 2)
          ])
        ]),
        _createElementVNode("div", {
          class: "icon_wrapper",
          onClick: searchHandle
        }, [...(_cache[3] || (_cache[3] = [
          _createElementVNode("i", { class: "iconfont icon-daohanglansousuo icon_item" }, null, -1)
        ]))]),
        _createElementVNode("div", {
          class: "icon_wrapper",
          onClick: skipPage
        }, [
          _cache[4] || (_cache[4] = _createElementVNode("i", { class: "iconfont icon-daohanglanxiaoxi icon_item" }, null, -1)),
          _withDirectives(_createElementVNode("div", _hoisted_5, [
            _createElementVNode("span", _hoisted_6, _toDisplayString(parseInt(count.value) > 99 ? '99+' : count.value), 1)
          ], 512), [
            [_vShow, count.value !== '0']
          ])
        ]),
        _withDirectives(_createElementVNode("div", {
          class: "master",
          onClick: hideMaster,
          onTouchmove: hideMaster
        }, [
          _createVNode(_Transition, { name: "pull" }, {
            default: _withCtx(() => [
              _withDirectives(_createElementVNode("div", {
                class: "select_wrapper",
                onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"])),
                onTouchmove: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.collegeList, (item) => {
                  return (_openBlock(), _createElementBlock("p", {
                    class: _normalizeClass(["select_item", { active: _unref(collegeId) === item.id }]),
                    key: item.id,
                    onClick: ($event: any) => (selectCollege(item.id))
                  }, _toDisplayString(item.collegeName), 11, _hoisted_7))
                }), 128))
              ], 544), [
                [_vShow, masterShow.value]
              ])
            ]),
            _: 1
          }),
          _cache[5] || (_cache[5] = _createElementVNode("div", { class: "triangle" }, null, -1))
        ], 544), [
          [_vShow, masterShow.value]
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})